import { useMutation } from 'react-query';
import request from '../../../../helpers/request';
import { getNameWithoutExt } from '../../../../helpers/attachments/getNameWithoutExt';

const createErrorMessage = (fileName) =>
  `Не удалось добавить вложение «${fileName}»`;

const mutationFn = ({
  addressId,
  typeId,
  acceptanceClientId,
  file,
  data,
  showErrorMessage = true,
}) => {
  const formData = new FormData();

  formData.append('file', file);

  const name = data?.name ?? getNameWithoutExt(file.name);

  formData.append('data', JSON.stringify({ name, ...data }));

  return request.post(
    `Acceptance/address/${addressId}/attachment`,
    formData,
    showErrorMessage ? createErrorMessage(name) : undefined,
    'Error',
    undefined,
    { typeId, acceptanceClientId },
    !showErrorMessage
  );
};

export const useAddRoomAttachmentMutation = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error' && options?.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
  });
